<template>
  <div>
    <div class="card height-100">
      <header class="header-card">
        <p> {{ $t('detailCatalogue.commentaireVente.title') }} </p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div v-if="!isDetail" class="column is-12">
            <commentaire
              v-model="produit.commentaireVente"
              :commentaires="commentaires"
              title="detailCatalogue.commentaireVente.title">
            </commentaire>
          </div>
          <b-field
            v-if="isDetail"
            :label="$t('detailCatalogue.commentaireVente.title')"
            class="column is-12"
            custom-class="has-text-default is-italic has-text-weight-light">
            <span class="has-text-weight-bold">
              {{ produit.commentaireVente }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import commentaire from '@/components/general/commentaire';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    commentaire,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    commentaires() {
      return this.parametre(PARAMETRES_KEYS.commentaire);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.commentaire,
      ]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>
